var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_48)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5938 12.1187H107.406C110.212 12.1307 112.9 13.248 114.884 15.2273C116.868 17.2065 117.988 19.8875 118 22.6866V47.2258H5V22.6866C5.00969 19.8868 6.12893 17.2044 8.11355 15.2246C10.0982 13.2448 12.7871 12.1283 15.5938 12.1187ZM38.3905 21.0629C40.0838 21.0629 41.7391 21.5638 43.147 22.5022C44.5549 23.4407 45.6523 24.7745 46.3003 26.3351C46.9483 27.8957 47.1178 29.6129 46.7875 31.2696C46.4571 32.9263 45.6417 34.4481 44.4444 35.6425C43.2471 36.837 41.7216 37.6504 40.0608 37.9799C38.4 38.3095 36.6786 38.1403 35.1142 37.4939C33.5498 36.8475 32.2127 35.7528 31.272 34.3483C30.3312 32.9438 29.8291 31.2926 29.8291 29.6034C29.8291 27.3383 30.7311 25.166 32.3367 23.5643C33.9423 21.9627 36.1199 21.0629 38.3905 21.0629ZM84.1772 21.0629C85.8705 21.0629 87.5258 21.5638 88.9337 22.5022C90.3417 23.4407 91.439 24.7745 92.087 26.3351C92.735 27.8957 92.9045 29.6129 92.5742 31.2696C92.2438 32.9263 91.4284 34.4481 90.2311 35.6425C89.0338 36.837 87.5083 37.6504 85.8475 37.9799C84.1867 38.3095 82.4653 38.1403 80.9009 37.4939C79.3365 36.8475 77.9994 35.7528 77.0587 34.3483C76.1179 32.9438 75.6158 31.2926 75.6158 29.6034C75.6158 27.3383 76.5178 25.166 78.1234 23.5643C79.729 21.9627 81.9066 21.0629 84.1772 21.0629Z",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.406 117H15.5938C12.7878 116.988 10.1003 115.871 8.11621 113.892C6.13211 111.912 5.0121 109.231 5 106.432L5 42.6943H118V106.414C117.995 109.217 116.878 111.904 114.893 113.888C112.908 115.871 110.216 116.99 107.406 117Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7251 113.615H106.275C108.482 113.605 110.596 112.727 112.156 111.17C113.716 109.614 114.597 107.505 114.607 105.304V42.6943H8.39355V105.285C8.40083 107.488 9.28095 109.597 10.8418 111.154C12.4027 112.711 14.5177 113.589 16.7251 113.597V113.615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1775 19.4209C86.5413 19.4184 88.8328 20.2336 90.6617 21.7277C92.4905 23.2217 93.7434 25.3022 94.2068 27.6145C94.6703 29.9268 94.3157 32.3278 93.2033 34.4085C92.091 36.4892 90.2899 38.1208 88.1068 39.0252C85.9238 39.9295 83.4939 40.0508 81.2312 39.3683C78.9686 38.6857 77.0132 37.2416 75.6983 35.2821C74.3834 33.3225 73.7903 30.9687 74.0201 28.6218C74.2499 26.2749 75.2884 24.0802 76.9586 22.4115L77.0598 22.3197C78.9608 20.4617 81.5161 19.421 84.1775 19.4209ZM84.1775 21.063C85.8707 21.063 87.526 21.5639 88.9339 22.5023C90.3419 23.4408 91.4392 24.7746 92.0872 26.3352C92.7352 27.8958 92.9047 29.613 92.5744 31.2697C92.244 32.9264 91.4286 34.4482 90.2313 35.6426C89.034 36.8371 87.5085 37.6505 85.8477 37.98C84.1869 38.3096 82.4655 38.1404 80.9011 37.494C79.3367 36.8476 77.9996 35.7529 77.0589 34.3484C76.1181 32.9439 75.616 31.2927 75.616 29.6035C75.616 27.3384 76.518 25.1661 78.1236 23.5644C79.7292 21.9628 81.9068 21.063 84.1775 21.063Z",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3903 19.4209C40.7542 19.4184 43.0457 20.2336 44.8746 21.7277C46.7034 23.2217 47.9563 25.3022 48.4197 27.6145C48.8832 29.9268 48.5285 32.3278 47.4162 34.4085C46.3039 36.4892 44.5028 38.1208 42.3197 39.0252C40.1366 39.9295 37.7068 40.0508 35.4441 39.3683C33.1815 38.6857 31.2261 37.2416 29.9112 35.2821C28.5963 33.3225 28.0032 30.9687 28.233 28.6218C28.4628 26.2749 29.5013 24.0802 31.1715 22.4115L31.2727 22.3197C33.1747 20.4634 35.7294 19.423 38.3903 19.4209ZM38.3903 21.063C40.0836 21.063 41.7389 21.5639 43.1468 22.5023C44.5547 23.4408 45.6521 24.7746 46.3001 26.3352C46.9481 27.8958 47.1176 29.613 46.7873 31.2697C46.4569 32.9264 45.6415 34.4482 44.4442 35.6426C43.2469 36.8371 41.7214 37.6505 40.0606 37.98C38.3998 38.3096 36.6784 38.1404 35.114 37.494C33.5496 36.8476 32.2125 35.7529 31.2718 34.3484C30.331 32.9439 29.8289 31.2927 29.8289 29.6035C29.8289 27.3384 30.7309 25.1661 32.3365 23.5644C33.9421 21.9628 36.1197 21.063 38.3903 21.063Z",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0645 10.1831C79.0645 7.83471 81.3267 6 84.1774 6C87.0282 6 89.2904 7.83471 89.2904 10.1831V29.6402C89.2904 31.9428 87.0098 33.8234 84.1774 33.8234C81.345 33.8234 79.0645 31.9887 79.0645 29.6402V10.1831Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2773 10.1831C33.2773 7.83471 35.5671 6 38.3903 6C41.2135 6 43.5033 7.83471 43.5033 10.1831V29.6402C43.5033 31.9428 41.2227 33.8234 38.3903 33.8234C35.5579 33.8234 33.2773 31.9887 33.2773 29.6402V10.1831Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.231 84.5439H38.1053C38.5419 84.5439 38.9606 84.7169 39.2693 85.0249C39.578 85.3328 39.7514 85.7505 39.7514 86.186V96.9191C39.749 97.3538 39.5748 97.7701 39.2666 98.0775C38.9584 98.3849 38.5411 98.5587 38.1053 98.5611H25.231C24.7935 98.5611 24.3739 98.3884 24.0637 98.0807C23.7536 97.7731 23.5781 97.3554 23.5757 96.9191V86.186C23.5781 85.7497 23.7536 85.332 24.0637 85.0243C24.3739 84.7166 24.7935 84.5439 25.231 84.5439Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8853 57.7573H97.8149C98.2523 57.7597 98.6709 57.9348 98.9794 58.2442C99.2878 58.5536 99.4609 58.9722 99.4609 59.4086V70.1325C99.4585 70.5672 99.2843 70.9835 98.9761 71.2909C98.668 71.5983 98.2507 71.7721 97.8149 71.7745H84.8853C84.4488 71.7745 84.0301 71.6015 83.7214 71.2936C83.4127 70.9856 83.2393 70.568 83.2393 70.1325V59.4086C83.2393 58.9722 83.4124 58.5536 83.7208 58.2442C84.0293 57.9348 84.4479 57.7597 84.8853 57.7573Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 65,
    r: 8,
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 91,
    r: 8,
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_335_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 62.5L62 67.5L73.5 58",
    stroke: "#7269EF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_335_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5 88.5L91.5 93.5L103 84",
    stroke: "#7269EF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.707 59.707L26.707 69.707",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.707 69.707L26.707 59.707",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 86L57 96",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 96L57 86",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_335_48",
    x: 52.5,
    y: 56.5,
    width: 26.5,
    height: 21.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_335_48"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_335_48",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_335_48",
    x: 82,
    y: 82.5,
    width: 26.5,
    height: 21.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_335_48"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_335_48",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 111,
    fill: "white",
    transform: "translate(5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonAppointment);
export default __webpack_public_path__ + "static/media/non-appointment.0806e051a8884e54a7a4083f00b39970.svg";
export { ForwardRef as ReactComponent };